import { forwardRef, type ComponentProps } from "react";

import { cn } from "@/lib/chillnn/cn";

import { Textarea } from "../../../input/textarea";
import { FormErrorMessage, FormItem, FormLabel } from "../../_base/form";

import type { ReactNode } from "react";

export type Props = {
	placeholder?: string;
	rows?: number;

	errorMessage?: string | undefined;
	label?: ReactNode;
} & ComponentProps<typeof Textarea>;

export const TextAreaFieldNew = forwardRef<HTMLTextAreaElement, Props>(
	({ placeholder, rows, errorMessage, label, ...props }: Props, ref) => {
		return (
			<FormItem>
				<FormLabel>{label}</FormLabel>
				<Textarea rows={rows} className={cn("min-h-[110px]")} placeholder={placeholder} {...props} ref={ref} />
				<FormErrorMessage>{errorMessage}</FormErrorMessage>
			</FormItem>
		);
	},
);
